<template>
  <el-form ref="form" :model="form" :inline="true" style="margin-bottom: -18px;" size="mini">
    <el-form-item :label="$l('project_search_label_pro_no')||'项目编号'" prop="prjNo">
      <el-input v-model="form.prjNo" clearable size="mini"></el-input>
    </el-form-item>
    <el-form-item :label="$l('project_search_label_pro_title')||'项目标题'" prop="prjTitle">
      <el-input v-model="form.prjTitle" clearable size="mini"></el-input>
    </el-form-item>
  <el-form-item :label="$l('project_search_label_customer')||'客户'" prop="custCode">
    <dict-select
      v-model="form.custCode"
      url="/digitalCenter/common/dict/customer"
      size="mini"
      style="width: 100%"
      :placeholder="$l('project_search_label_customer')||'客户'"
      filterable
      clearable
    ></dict-select>
  </el-form-item>
    <el-form-item>
      <el-button style="float: left" type="primary" @click="query">
        {{$l('project_search_btn_search')||'查询'}}
      </el-button>
    </el-form-item>
    <el-form-item>
      <el-button style="float: left" @click="reset" class="d2-mr-10">
        {{$l('project_search_btn_reset')||'重置'}}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  data () {
    return {
      form: {
        prjNo: '',
        prjTitle: '',
        custCode: '',
        prjStatusList: ['P']
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    }
  },
  created () {
    this.query()
  }
}
</script>
